module.exports = __webpack_public_path__ + "img/cartes_bancaires.280b4bd7.svg";